module.exports = __webpack_public_path__ + "static/media/team_04.61cb5983.jpg";